import React from 'react';
export const ExternalButton = React.forwardRef<HTMLAnchorElement, any>(
  (props, ref) => (
    <a
      {...props}
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
      ref={ref}
    >
      {props.children}
    </a>
  )
);
